import { PaymentPackageEnum, PaymentPackageType } from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";
import { $t } from "@/lib/helpers/i18nHelper";
import config from "@/config";

export interface PaymentPackageGroup {
  type: PaymentPackageType;
  name: string;
  description: string;
  addButtonText: string;
  editDescriptionType: string;
  editDescription: string;
  hideCosts?: boolean;
}

let packageTypes: PaymentPackageGroup[] = [
  {
    type: PaymentPackageEnum.SUBSCRIPTION,
    name: $t("Subscription price"),
    description: $t("pricing_content_subscription_description"),
    addButtonText: $t("Add {0}", [$t("Subscription Price")]),
    editDescriptionType: $t("per month"),
    editDescription: $t("pricing_content_subscription_edit_description"),
  },
];

export { packageTypes };
